import { Helper } from '../Helper';
export class ArrRangeHelper extends Helper {
    constructor(options) {
        super();
        this.map =
            options.map === undefined
                ? () => {
                }
                : options.map;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitSysCall(node, 'Neo.Enumerator.Create');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, 0);
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Enumerator.Next');
            },
            each: (innerOptions) => {
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PICK');
                sb.emitOp(node, 'OVER');
                this.map(innerOptions);
                sb.emitOp(node, 'APPEND');
                sb.emitOp(node, 'INC');
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
            },
        }));
    }
}

//# sourceMappingURL=ArrRangeHelper.js.map
